var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tagFilter"},_vm._l((_vm.filterOptions),function(filterOption){return _c('span',{key:filterOption.value,class:[
        filterOption.value === _vm.filterStatus ? 'active' : '',
        'status-item'
      ],on:{"click":function($event){return _vm.filterByStatus(filterOption.value)}}},[_c('i',{class:['fas icon-status', filterOption.iconClass]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(filterOption.label))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf5d6146","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-out/components/filter-by-status-header.vue
// module id = s1ex
// module chunks = 89